// extracted by mini-css-extract-plugin
module.exports = {"thanks":"styles_thanks__n3LzV","poll":"styles_poll__3Kboj","pollOptions":"styles_pollOptions__33SiU"};